import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/ui/select/Select";

function CourseSort({ selectedSortBy, setSelectedSortBy }) {
	const { t } = useTranslation();

	return (
		<Select value={selectedSortBy} onValueChange={setSelectedSortBy}>
			<SelectTrigger>
				<SelectValue placeholder={t("courses:sort.placeholder")} />
			</SelectTrigger>
			<SelectContent>
				<SelectGroup>
					<SelectLabel>{t("courses:sort.label")}</SelectLabel>
					<SelectItem value="date-desc">
						{t("courses:sort.newest")}
					</SelectItem>
					<SelectItem value="most-liked">
						{t("courses:sort.mostLiked")}
					</SelectItem>
					<SelectItem value="most-watched">
						{t("courses:sort.mostWatched")}
					</SelectItem>
				</SelectGroup>
			</SelectContent>
		</Select>
	);
}

export default CourseSort;
